/** 跟单仓位 ID（兼容 positionId / id / position_id） */
export function resolveAicopyPositionId(orderOrItem) {
  if (!orderOrItem) return null;
  const id = orderOrItem.positionId ?? orderOrItem.id ?? orderOrItem.position_id;
  if (id == null || id === "") return null;
  return id;
}

/** 毛收益数值（≥0），用于可提收益计算与前置校验 */
export function parseAicopyGrossProfitRaw(item) {
  const raw = item?.profit ?? item?.grossProfit ?? item?.gross_profit;
  const n = parseFloat(String(raw ?? "").replace(/,/g, ""));
  return Number.isFinite(n) ? Math.max(0, n) : 0;
}

/**
 * 结束跟单后用于「快捷换汇」试算的 USDT 数量估算：本金 + 盈亏（接口原始值，仅作试算参考）。
 */
export function computeEstimatedSettledUsdtStr(order) {
  if (!order) return "0";
  const invStr = order.totalInvestAmount ?? order.totalInvestment ?? "0";
  const inv = parseFloat(String(invStr).replace(/,/g, "")) || 0;
  let p = 0;
  if (order.profitRaw !== undefined && order.profitRaw !== null) {
    const n = Number(order.profitRaw);
    p = Number.isFinite(n) ? n : 0;
  } else {
    const n = parseFloat(String(order.profit ?? "").replace(/,/g, ""));
    p = Number.isFinite(n) ? n : 0;
  }
  const total = inv + p;
  if (!Number.isFinite(total) || total <= 0) return "0";
  const s = total.toFixed(8).replace(/\.?0+$/, "");
  return s || "0";
}

/**
 * 本次可提取的毛收益（USDT 数字字符串），= gross − 已提取；用于提取收益接口与后续换汇试算。
 * @param {{ grossProfitRaw?: number, withdrawnProfitAmount?: string, withdrawn_profit_amount?: string }} order
 */
export function computeWithdrawableProfitUsdtStr(order) {
  if (!order) return "0";
  const gross = Number(order.grossProfitRaw) || 0;
  const withdrawnRaw = order.withdrawnProfitAmount ?? order.withdrawn_profit_amount ?? "0";
  const withdrawn = Math.max(0, parseFloat(String(withdrawnRaw).replace(/,/g, "")) || 0);
  const remain = Math.max(0, gross - withdrawn);
  if (remain <= 0) return "0";
  const s = remain.toFixed(8).replace(/\.?0+$/, "");
  return s || "0";
}
